import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
function PopReservationClassRoom(props) {
  const {open, close} = props;
  const listItems = ['201호 2023, 05,12 ~ 2024, 01, 12 (수, 목, 금)', '202호 (월, 화, 수, 목, 금)', '203호 (월, 화, 금)', '204호 ( 수, 목, 금)', '204호 ( 수, 목, 금)', '204호 ( 수, 목, 금)', '204호 ( 수, 목, 금)', '204호 ( 수, 목, 금)', '204호 ( 수, 목, 금)'];

  const [selectedItem, setSelectedItem] = useState(null);
  return (
    <Modal open={open} close={close} type="pop_reservation_classroom">
      <h2 className="pop_tit">강의실 관리</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="com_input_wrap">
            <input type="text" className="input" placeholder="호실명 입력" />
          </li>
          <li className="com_input_wrap">
            <div className="input_box">
              <div className="com_check_date">
                <input type="checkbox" className="chk_date" id="mon" defaultChecked />
                <label htmlFor="mon">월</label>
                <input type="checkbox" className="chk_date" id="tue" />
                <label htmlFor="tue">화</label>
                <input type="checkbox" className="chk_date" id="wed" />
                <label htmlFor="wed">수</label>
                <input type="checkbox" className="chk_date" id="thu" />
                <label htmlFor="thu">목</label>
                <input type="checkbox" className="chk_date" id="fri" />
                <label htmlFor="fri">금</label>
                <input type="checkbox" className="chk_date" id="sat" />
                <label htmlFor="sat">토</label>
                <input type="checkbox" className="chk_date" id="sun" />
                <label htmlFor="sun">일</label>
              </div>
            </div>
          </li>
          <li className="com_input_wrap flex_row gap">
            <span className="com_check_box">
              <input type="checkbox" name="chk" id="chk010" className="com_chk" />
              <label htmlFor="chk010">무제한</label>
            </span>
            <div className="date_wrap">
              <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
              <span className="divider"> ~ </span>
              <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
            </div>
          </li>
        </ul>
        <div className="com_btn_wrap center bottom">
          <button className="com_btn orange xs">등록</button>
        </div>
        <hr className="com_divider" />
        <ul className="com_scroll_list pick mb_no">
          {listItems.map((item, index) => (
            <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
              <div className="check">
                <input type="radio" name="rdo" id={`rdo${index}`} className="com_chk circle" />
                <label htmlFor={`rdo${index}`}> {item}</label>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn gray xs">선택한 호실 삭제</button>
      </div>
    </Modal>
  );
}

export default PopReservationClassRoom;
